import { render } from "./TreeItem.vue?vue&type=template&id=380c0e33&scoped=true"
import script from "./TreeItem.vue?vue&type=script&lang=js"
export * from "./TreeItem.vue?vue&type=script&lang=js"

import "./TreeItem.vue?vue&type=style&index=0&id=380c0e33&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-380c0e33"

export default script